export default __webpack_public_path__ + "static/media/demo.17df1620.gif";